import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from '../i18n/useTranslation';
import { Heart } from 'lucide-react';
// Site-wide floating donate button (C10). Positioned bottom-right above the
// mobile bottom-nav. Hidden on pages where it would obstruct UX — the donate
// page itself, auth flows, and the finger-signature consent page.
const HIDE_ON = [
    '/donate',
    '/p/donate',
    '/login',
    '/register',
    '/parent/consent',
];
export default function FloatingDonateButton() {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    if (HIDE_ON.some((p) => pathname.startsWith(p)))
        return null;
    return (_jsxs(Link, { to: "/donate", "aria-label": t('donate.button'), style: {
            position: 'fixed',
            right: 16,
            bottom: 92,
            zIndex: 90,
            background: 'linear-gradient(135deg, #ef4444 0%, #f97316 100%)',
            color: '#fff',
            padding: '12px 18px',
            borderRadius: 999,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
            fontWeight: 700,
            fontSize: 14,
            textDecoration: 'none',
            boxShadow: '0 10px 30px rgba(239,68,68,0.35)',
            minHeight: 48,
        }, children: [_jsx(Heart, { size: 16, fill: "currentColor" }), _jsx("span", { className: "hidden sm:inline", children: t('donate.button') })] }));
}
